import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';

ChartJS.register(
  ArcElement,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
);

// Brand-aligned palette (mirrors helpdesk statistics colors)
export const CHART_COLORS = [
  '#5B7304', // moss-primary
  '#EA8162', // brick
  '#31403B', // neutral-deep
  '#F59E0B', // amber
  '#3B82F6', // blue
  '#8B5CF6', // violet
  '#EC4899', // pink
  '#14B8A6', // teal
  '#F97316', // orange
  '#6366F1', // indigo
  '#84CC16', // lime
  '#06B6D4', // cyan
  '#A855F7', // purple
  '#F43F5E', // rose
  '#22C55E', // green
];

export const CHART_COLORS_ALPHA = CHART_COLORS.map((c) => `${c}CC`);

export const COMMON_TOOLTIP = {
  backgroundColor: '#31403B',
  titleColor: '#F9F0EE',
  bodyColor: '#F9F0EE',
  borderColor: '#EA8162',
  borderWidth: 1,
  padding: 12,
} as const;
